function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { maestroSharedThemeOptions } from "./shared";

var maestroLightThemeDefaultColors = _extends({}, maestroSharedThemeOptions.palette["default"], {
  tint: 'rgb(242, 252, 239)',
  light: 'rgb(122, 217, 95)',
  main: 'rgb(102, 175, 78)',
  dark: 'rgb(77, 150, 53)',
  contrastText: 'rgb(255, 255, 255)'
});

export var maestroLightThemeOptions = _extends({}, maestroSharedThemeOptions, {
  palette: _extends({}, maestroSharedThemeOptions.palette, {
    type: 'light',
    "default": maestroLightThemeDefaultColors,
    primary: maestroLightThemeDefaultColors,
    success: _extends({}, maestroSharedThemeOptions.palette.success, {
      light: 'rgb(122, 217, 95)',
      main: 'rgb(102, 175, 78)',
      dark: 'rgb(77, 150, 53)',
      contrastText: 'rgb(255,255,255)'
    })
  })
});